import { Box } from "@mui/material";
import clsx from "clsx";
import React from "react";
import styles from "./PromptTextWithActions.module.scss";

type PromptTextWithActionsProps = {
	prompt?: string;
	refine_prompt?: string;
	is_refine?: boolean;
	generation_prefix?: string;
	restyle_portrait?: boolean;
	promptClassName?: string;
	resultHeaderActions?: React.ReactNode;
};

const PromptTextWithActions = ({
	prompt,
	refine_prompt,
	is_refine,
	generation_prefix,
	restyle_portrait,
	promptClassName,
	resultHeaderActions,
}: PromptTextWithActionsProps) => {
	if (!prompt && !(is_refine && refine_prompt)) {
		return null;
	}

	return (
		<Box className={styles.headerText}>
			<Box className={clsx(styles.promptText, promptClassName)}>
				{is_refine && refine_prompt ? (
					refine_prompt
				) : generation_prefix && !restyle_portrait ? (
					<>
						<span className={styles.generationPrefix}>{generation_prefix}</span>
						{prompt}
					</>
				) : (
					prompt
				)}
			</Box>
			{resultHeaderActions}
		</Box>
	);
};

export default PromptTextWithActions;
